import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Layout from "../Components/Layout/Layout";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { getEvents } from "../Redux/Actions/event";
import CreateEventModal from "../Components/CommanModals/CreateEventModal";
import { Encryptedid } from "../Utils/bcrypt";
import {
  capitalize,
  formatTimeCalenderEvent,
  formatLocation,
  months,
} from "../Utils/commonFiles";
import { setVisibleRange } from "../Redux/Reducers/eventSlice";
import moment from "moment/moment";
import Table from "react-bootstrap/Table";

export default function Events() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const calendarRef = useRef(null);

  const eventList = useSelector((e) => e.eventAuth.eventsList);

  // const customerName = eventList.events.map((event) => event.client?.fullname);
  // const customerName =
  //   eventList?.event
  //     ?.map((event) => event.client?.fullName)
  //     ?.filter(Boolean)
  //     .join(", ") || "";

  // "Alice Johnson, Bob Smith, Charlie Brown"

  const MusicianList = useSelector((e) => e.eventAuth.MusiciansList);

  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [lastVisibleRange, setLastVisibleRange] = useState(null);
  const [selectedMusician, setSelectedMusician] = useState("");
  const [viewMode, setViewMode] = useState("calendar");
  const [sortConfig, setSortConfig] = useState({
    key: "date",
    direction: "asc",
  });
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1);
  const isProgrammaticUpdate = useRef(false);

  const handleDateClick = (arg) => {
    // alert(arg.dateStr);
  };
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleChange = (e) => {
    setSelectedMusician(e.target.value);
  };

  const years = Array.from({ length: 15 }, (_, i) => 2024 + i);

  const handleYearChange = (year) => {
    setSelectedYear(year);
    if (calendarRef.current) {
      isProgrammaticUpdate.current = true;
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(
        moment(`${year}-${selectedMonth}-01`).toDate()
      );
    }
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    if (calendarRef.current) {
      isProgrammaticUpdate.current = true;
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(
        moment(`${selectedYear}-${month}-01`).toDate()
      );
    }
  };

  // Handle data fetching for list view when dropdown values change
  useEffect(() => {
    if (viewMode === "list") {
      const startOfMonth = moment(`${selectedYear}-${selectedMonth}-01`).startOf("month").toDate();
      const endOfMonth = moment(startOfMonth).endOf("month").toDate();
      const visibleStart = startOfMonth.toISOString().split("T")[0];
      const visibleEnd = endOfMonth.toISOString().split("T")[0];

      if (!lastVisibleRange || lastVisibleRange.start !== visibleStart || lastVisibleRange.end !== visibleEnd) {
        dispatch(startstopLoading(true));
        dispatch(getEvents({ startOfMonth: visibleStart, endOfMonth: visibleEnd })).then(() => {
          dispatch(startstopLoading(false));
        });
        setLastVisibleRange({ start: visibleStart, end: visibleEnd });
      }
    }
  }, [selectedYear, selectedMonth, viewMode]);




  useEffect(() => {
    if (eventList?.event?.length) {
      let transformedEvents = eventList?.event?.map((event) => {
        console.log('======isDounted value for event:', event._id, event.isDiscounted);
        const eventDate = moment(event.eventDate);
        const fromTime = moment(event.eventTime.from);
        const toTime = moment(event.eventTime.to);
        const start = eventDate.clone().set({
          hour: fromTime.hour(),
          minute: fromTime.minute(),
          second: fromTime.second(),
          millisecond: 0,
        });

        const end = eventDate.clone().set({
          hour: toTime.hour(),
          minute: toTime.minute(),
          second: toTime.second(),
          millisecond: 0,
        });
        if (end.isBefore(start)) {
          end.add(1, "day");
        }
        return {
          id: event._id,
          title: event.eventName,
          start: start.toDate(),
          end: end.toDate(),
          extendedProps: {
            customername: event.client?.fullName,
            location: event.location,
            musician: event.musician,
            reference: event.reference,
            price: event.price,
            client: event.client._id,
            islocked: event?.client?.islocked || false,
            isDiscounted: event.isDiscounted || false
          },
        };
      });
      if (selectedMusician) {
        transformedEvents = transformedEvents.filter(
          (res) => res?.extendedProps?.musician?._id === selectedMusician
        );
      }
      setEvents(transformedEvents);
    }
  }, [eventList, selectedMusician]);

  const handleEventDetail = (data) => {
    navigate(
      `/events-details/${Encryptedid(data?.id)}?clientId=${data?.extendedProps.client
      }`
    );
  };

  const renderEventContent = (eventInfo) => {
    const { start, end, title, extendedProps } = eventInfo.event;
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startTime = formatTimeCalenderEvent(startDate);
    const endTime = formatTimeCalenderEvent(endDate);




    return (
      <div
        onClick={() => handleEventDetail(eventInfo.event)}
        style={{ cursor: "pointer" }}
        className="w-100"
      >
        <div className="d-flex justify-content-between">
          {/* <b>{capitalize(title)}</b> */}
          {/* <div>
            <i>{`At ${capitalize(extendedProps?.location)}`}</i>
          </div> */}
        </div>
        <div className="calendar-event-name">
          <b className="calendar-event-name-text">{extendedProps?.customername || "N/A"}</b>
          {extendedProps.isDiscounted ? <span className="calendar-event-discount-dot"></span> : ""}
        </div>
        <div className="calendar-event-reference"><b>Ref</b> : {extendedProps?.reference || "N/A"}</div>
        {/* <div>
          {startTime} - {endTime}
        </div> */}
      </div>
    );
  };

  const handleDatesSet = (arg) => {
    const startDate = arg.start;
    const endDate = arg.end;

    const visibleStart = new Date(startDate).toISOString().split("T")[0];
    const visibleEnd = new Date(endDate).toISOString().split("T")[0];
    dispatch(setVisibleRange({ start: visibleStart, end: visibleEnd }));

    // Update dropdowns only if this is user navigation (not programmatic)
    if (!isProgrammaticUpdate.current) {
      const currentViewDate = moment(startDate).add(15, 'days');
      const newYear = currentViewDate.year();
      const newMonth = currentViewDate.month() + 1;

      if (newYear !== selectedYear) {
        setSelectedYear(newYear);
      }
      if (newMonth !== selectedMonth) {
        setSelectedMonth(newMonth);
      }
    } else {
      isProgrammaticUpdate.current = false;
    }

    if (
      !lastVisibleRange ||
      lastVisibleRange.start !== visibleStart ||
      lastVisibleRange.end !== visibleEnd
    ) {
      dispatch(startstopLoading(true));
      dispatch(
        getEvents({ startOfMonth: visibleStart, endOfMonth: visibleEnd })
      ).then(() => {
        dispatch(startstopLoading(false));
      });
      setLastVisibleRange({ start: visibleStart, end: visibleEnd });
    }
  };

  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 2);

  const isPastEvent = (eventDate) => {
    const currentDate = new Date();
    const eventDateObj = new Date(eventDate);
    return eventDateObj.getTime() < currentDate.getTime();
  };

  const getEventClassNames = (arg) => {
    const musicianName = arg.event.extendedProps?.musician?.fullName || "";
    const classes = [];

    if (isPastEvent(arg.event.start)) {
      classes.push("past-event");
    }
    const normalizedName = musicianName.trim().toLowerCase();
    if (
      normalizedName.includes("bianca") &&
      normalizedName.includes("blezard")
    ) {
      classes.push("bianca-event");
    } else if (normalizedName.includes("estere")) {
      classes.push("estere-event");
    }

    return classes;
  };

  // Sorting function for list view
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  // Sorted events for list view
  // const sortedEvents = [...events].sort((a, b) => {
  //   if (sortConfig.key === "date") {
  //     const dateA = new Date(a.start);
  //     const dateB = new Date(b.start);
  //     return sortConfig.direction === "asc" ? dateA - dateB : dateB - dateA;
  //   } else if (sortConfig.key === "reference") {
  //     const refA = a.extendedProps.reference || "";
  //     const refB = b.extendedProps.reference || "";
  //     return sortConfig.direction === "asc"
  //       ? refA.localeCompare(refB)
  //       : refB.localeCompare(refA);
  //   }
  //   return 0;
  // });
  const sortedEvents = useMemo(() => {
    if (!events) return [];

    // Filter events to only show those in the selected month for list view
    const filteredEvents = viewMode === "list"
      ? events.filter(event => {
        const eventMonth = moment(event.start).month() + 1;
        const eventYear = moment(event.start).year();
        return eventMonth === selectedMonth && eventYear === selectedYear;
      })
      : events;

    return [...filteredEvents].sort((a, b) => {
      if (sortConfig.key === "date") {
        const dateA = new Date(a.start);
        const dateB = new Date(b.start);
        return sortConfig.direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      if (sortConfig.key === "reference") {
        const refA = a.extendedProps?.reference || "";
        const refB = b.extendedProps?.reference || "";
        return sortConfig.direction === "asc"
          ? refA.localeCompare(refB)
          : refB.localeCompare(refA);
      }

      return 0;
    });
  }, [events, sortConfig, viewMode, selectedMonth, selectedYear]);

  // List view component
  const renderListView = () => (
    <div className="inner-filter-field">
      <Table striped bordered hover responsive className="mt-5">
        <thead>
          <tr>
            <th
              onClick={() => handleSort("date")}
              style={{ cursor: "pointer" }}
            >
              Date{" "}
              {sortConfig.key === "date" &&
                (sortConfig.direction === "asc" ? "↑" : "↓")}
            </th>
            <th>Customer name</th>
            <th
              onClick={() => handleSort("reference")}
              style={{ cursor: "pointer" }}
            >
              Reference{" "}
              {sortConfig.key === "reference" &&
                (sortConfig.direction === "asc" ? "↑" : "↓")}
            </th>
            <th>Package</th>
            <th>Musician</th>
            <th>Songs Confirmed</th>
            <th>Venue</th>
            <th>Time</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {sortedEvents.map((event) => (
            <tr key={event.id}>
              <td>{moment(event.start).format("DD/MM/YYYY")}</td>
              <td>{event?.extendedProps?.customername || "NA"}</td>
              <td>{event.extendedProps.reference || "N/A"}</td>
              <td>{capitalize(event.title)}</td>
              <td>{event.extendedProps.musician?.fullName || "Bianca"}</td>
              <td>{event.extendedProps?.islocked ? 'Yes' : 'No'}</td>
              <td
                className="truncate"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                style={{ cursor: 'default' }}
                title={capitalize(event.extendedProps.location)}
              >
                {formatLocation(capitalize(event.extendedProps.location))}
              </td>
              <td>
                {formatTimeCalenderEvent(event.start)} -{" "}
                {formatTimeCalenderEvent(event.end)}
              </td>
              <td>
                <button
                  className="convert-btn"
                  onClick={() => handleEventDetail(event)}
                >
                  Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );

  const goToPrevMonth = () => {
    let newMonth = selectedMonth - 1;
    let newYear = selectedYear;

    if (newMonth < 1) {
      newMonth = 12;
      newYear -= 1;
    }

    handleMonthChange(newMonth);
    if (newYear !== selectedYear) {
      handleYearChange(newYear);
    }
  };

  const goToNextMonth = () => {
    let newMonth = selectedMonth + 1;
    let newYear = selectedYear;

    if (newMonth > 12) {
      newMonth = 1;
      newYear += 1;
    }

    handleMonthChange(newMonth);
    if (newYear !== selectedYear) {
      handleYearChange(newYear);
    }
  };

  const hasEventsInMonth = (year, month) => {
    return events.some((event) => {
      const eventMonth = moment(event.start).month() + 1;
      const eventYear = moment(event.start).year();
      return eventMonth === month && eventYear === year;
    });
  };

  const isPrevDisabled = () => {
    let prevMonth = selectedMonth - 1;
    let prevYear = selectedYear;

    if (prevMonth < 1) {
      prevMonth = 12;
      prevYear = selectedYear - 1;
    }

    // Use same logic as calendar's validRange (currentDate is 2 months before today)
    const prevMonthDate = moment(`${prevYear}-${prevMonth}-01`);
    const minAllowedDate = moment(currentDate);

    return prevMonthDate.isBefore(minAllowedDate, 'month');
  };

  return (
    <Layout>
      <Container fluid className="main-table-box">
        <div className="comn-table-title gap-2">
          <div>
            <button onClick={handleOpen}>Create Event</button>
          </div>
          <div className="">
            <select
              id="category"
              value={selectedMusician}
              onChange={handleChange}
              className="form-control w-70 me-3 custom-select-filter filter"
            >
              <option value="" disabled>
                Select Musician
              </option>
              <option value="">All Musicians</option>
              {MusicianList?.map((musician) => (
                <option key={musician._id} value={musician._id}>
                  {musician.fullName}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button
              variant={viewMode === "calendar" ? "primary" : "outline-primary"}
              onClick={() => setViewMode("calendar")}
              className="me-2"
            >
              Calendar View
            </button>
            <button
              variant={viewMode === "list" ? "primary" : "outline-primary"}
              onClick={() => setViewMode("list")}
            >
              List View
            </button>
          </div>
        </div>

        {/* {(viewMode === "calendar"|| viewMode === "list") && ( */}
        <div className="d-flex gap-2 mb-3">
          <select
            value={selectedYear}
            onChange={(e) => handleYearChange(Number(e.target.value))}
            className="form-control set-width me-3 custom-select-filter filter"
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
          <select
            value={selectedMonth}
            onChange={(e) => handleMonthChange(Number(e.target.value))}
            className="form-control set-width me-3 custom-select-filter filter"
          >
            {months.map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
        </div>
        {/* )} */}

        <div className="schedule_main">
          {viewMode === "calendar" ? (
            <div className="inner-filter-field">
              <FullCalendar
                timeZone="local"
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                headerToolbar={{
                  left: "prev,next",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                initialView="dayGridMonth"
                dateClick={(e) => handleDateClick(e)}
                events={events}
                eventContent={renderEventContent}
                editable={false}
                weekends={true}
                eventTimeFormat={{
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }}
                validRange={{
                  start: currentDate.toISOString().split("T")[0],
                }}
                visibleRange={{
                  start: new Date().toISOString().split("T")[0],
                }}
                datesSet={handleDatesSet}
                eventClassNames={getEventClassNames}
                eventDidMount={(info) => {
                  setTimeout(() => {
                    const eventElement = info.el;
                    const parentElement = eventElement.closest(
                      `.fc-daygrid-event-harness`
                    );
                    if (parentElement) {
                      if (isPastEvent(info.event.start)) {
                        parentElement.classList.add("past-event");
                      } else {
                        parentElement.classList.remove("past-event");
                      }
                    }
                  }, 0);
                }}
              />
            </div>
          ) : (
            <>
              <div className="fc-header-toolbar d-flex justify-content-between align-items-center">

                <div className="fc-button-group custom-nav-group">
                  <button
                    type="button"
                    className="fc-prev-button fc-button fc-button-primary"
                    onClick={goToPrevMonth}
                    disabled={isPrevDisabled()}
                  >
                    <span className="fc-icon fc-icon-chevron-left"></span>
                  </button>

                  <button
                    type="button"
                    className="fc-next-button fc-button fc-button-primary"
                    onClick={goToNextMonth}
                  >
                    <span className="fc-icon fc-icon-chevron-right"></span>
                  </button>
                </div>

                <h2 className="fc-toolbar-title-2 m-0">
                  {moment(`${selectedYear}-${selectedMonth}-01`).format("MMMM YYYY")}
                </h2>

              </div>

              {renderListView()}
            </>
          )}
        </div>
        <div className="mb-0">
          <p className="pb-4"></p>
        </div>
      </Container>
      <CreateEventModal show={showModal} handleClose={handleClose} />
    </Layout >
  );
}
